import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiMenuItem: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          '&:hover': {
            color: theme.palette.primary.main,
            background: 'transparent',
          },
          '&.Mui-selected': {
            background: 'transparent !important',
            '&:hover': {
              color: theme.palette.primary.main,
              background: 'transparent',
            }
          }
        }
      }
    }
  };
}
